import Papa from 'papaparse';

export default class Tools {

  filterObject(obj) {
    Object.keys(obj).forEach((key) => (obj[key] == null) && delete obj[key]);
  }

  downloadCSV(data, columns, filename) {
    let csv = Papa.unparse({data, fields: columns})

    if (csv == null) return;

    let blob = new Blob([csv]);
    if (window.navigator.msSaveOrOpenBlob) {  // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
      window.navigator.msSaveBlob(blob, filename);
    } else {
      let a = window.document.createElement("a");
      a.href = window.URL.createObjectURL(blob, {type: "text/plain"});
      a.download = filename;
      document.body.appendChild(a);
      a.click();  // IE: "Access is denied"; see: https://connect.microsoft.com/IE/feedback/details/797361/ie-10-treats-blob-url-as-cross-origin-and-denies-access
      document.body.removeChild(a);
    }
  }

  /**
   * https://mapstyle.withgoogle.com/
   * @type {string}
   */
  mapImgSrc (locations, zoom, w, h, scale, reqCenter = true) {
    let url = '//maps.googleapis.com/maps/api/staticmap',
      markers = [],
      query = [],
      center = undefined;

    let arrQuery = [
      ['key', window.GOOGLE_MAP_API_KEY],
      ['maptype', 'roadmap'],
      ['size', `${w}x${h}`],
      ['scale', scale],
      [
        'style',
        [
          'element:geometry',
          'color:0xf5f5f5',
        ].join('|')
      ],
      [
        'style',
        [
          'element:labels.icon',
          'visibility:off',
        ].join('|')
      ],
      [
        'style',
        [
          'element:labels.text.fill',
          'color:0x616161',
        ].join('|')
      ],
      [
        'style',
        [
          'element:labels.text.stroke',
          'color:0xf5f5f5',
        ].join('|')
      ],
      [
        'style',
        [
          'feature:administrative.land_parcel',
          'element:labels.text.fill',
          'color:0xbdbdbd',
        ].join('|')
      ],
      [
        'style',
        [
          'feature:poi',
          'element:geometry',
          'color:0xeeeeee',
        ].join('|')
      ],
      [
        'style',
        [
          'feature:poi',
          'element:labels.text.fill',
          'color:0x757575',
        ].join('|')
      ],
      [
        'style',
        [
          'feature:poi.park',
          'element:geometry',
          'color:0xe5e5e5',
        ].join('|')
      ],
      [
        'style',
        [
          'feature:poi.park',
          'element:labels.text.fill',
          'color:0x9e9e9e',
        ].join('|')
      ],
      [
        'style',
        [
          'feature:road',
          'element:geometry',
          'color:0xffffff',
        ].join('|')
      ],
      [
        'style',
        [
          'feature:road.arterial',
          'element:labels.text.fill',
          'color:0x757575',
        ].join('|')
      ],
      [
        'style',
        [
          'feature:road.highway',
          'element:geometry',
          'color:0xdadada',
        ].join('|')
      ],
      [
        'style',
        [
          'feature:road.highway',
          'element:labels.text.fill',
          'color:0x616161',
        ].join('|')
      ],
      [
        'style',
        [
          'feature:road.local',
          'element:labels.text.fill',
          'color:0x9e9e9e',
        ].join('|')
      ],
      [
        'style',
        [
          'feature:transit.line',
          'element:geometry',
          'color:0xe5e5e5',
        ].join('|')
      ],
      [
        'style',
        [
          'feature:transit.station',
          'element:geometry',
          'color:0xeeeeee',
        ].join('|')
      ],
      [
        'style',
        [
          'feature:water',
          'element:geometry',
          'color:0xc9c9c9',
        ].join('|')
      ],
      [
        'style',
        [
          'feature:water',
          'element:labels.text.fill',
          'color:0x9e9e9e',
        ].join('|')
      ],
    ];

    for(let i in arrQuery) {
      query.push(`${encodeURI(arrQuery[i][0])}=${encodeURI(arrQuery[i][1])}`);
    }

    if(zoom > 0) {
      query.push(`zoom=${encodeURI(zoom)}`);
    }

    for(let i = 0; i < locations.length; i++) {
      let {latitude, longitude, address, color = '149847'} = locations[i],
        strAddress = latitude && longitude ? `${latitude},${longitude}` : address,
        queryData = ['size:mid', `color:0x${color}`, strAddress].join('|');
      if (reqCenter && center === undefined) {
        center = strAddress;
        query.push(`center=${encodeURI(center)}`);
      }

      query.push(`${encodeURI('markers')}=${encodeURI(queryData)}`);
    }

    return `${url}?${query.join('&')}`;
  }

  formatDateWithFullYear (date) {
    return date.toLocaleDateString('en-AU', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
  }

  formatDate (date) {
    return date.toLocaleDateString('en-AU', {
      year: '2-digit',
      month: '2-digit',
      day: '2-digit',
    });
  }

  formatTimeWithOutTimeZone (date) {
    return date.toLocaleDateString('en-AU', {
      hour: '2-digit',
      hour12: true
    });
  }

  formatDateWithOutYear (date, timeZone) {
    return date.toLocaleDateString('en-AU', {
      timeZone: timeZone,
      month: '2-digit',
      day: '2-digit'
    }).replace(/\s+/g, '');
  }

  formatDateTimeWithOutSeconds (date, timeZone) {
    return date.toLocaleString('en-AU', {
      year:'numeric',
      month: 'numeric',
      day: 'numeric',
      hour:'2-digit',
      minute:'2-digit',
      hour12: false
    }).split(', ').reverse().join(' ');
  }

  formatTime (date, timeZone) {
    return date.toLocaleTimeString('en-AU', {
      timeZone: timeZone,
      hour: '2-digit',
      hour12: true
    });
  }

  getTimeZoneOffset (date, timeZone) {
    let options = {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'};
    let options_for_difference = {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'};

    options.timeZone = timeZone;
    options.timeZoneName = 'long';

    let dateObject = date.toLocaleString('en-AU', options);

    options_for_difference.timeZone = timeZone;
    options_for_difference.timeZoneName = 'short';

    let dateObjectForDifference  = date.toLocaleString('GMT', options_for_difference);
    return {
      zone: dateObject,
      difference: dateObjectForDifference.substr(dateObjectForDifference.lastIndexOf(' ') + 1)
    };
  }

  formatDateTime (date) {
    return `${this.formatDate(date)} ${date.toLocaleString('en-AU', {
      hour: 'numeric',
      hour12: true
    }).replace(/\s+/g, '')}`;
  }

  humanizedTimeSpan(date, ref_date, date_formats, time_units) {
    // Copyright (C) 2011 by Will Tomlins
    //
    // Github profile: http://github.com/layam
    //
    // Permission is hereby granted, free of charge, to any person obtaining a copy
    // of this software and associated documentation files (the "Software"), to deal
    // in the Software without restriction, including without limitation the rights
    // to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
    // copies of the Software, and to permit persons to whom the Software is
    // furnished to do so, subject to the following conditions:
    //
    // The above copyright notice and this permission notice shall be included in
    // all copies or substantial portions of the Software.
    //
    // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    // AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
    // LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
    // OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
    // THE SOFTWARE.
    //Date Formats must be be ordered smallest -> largest and must end in a format with ceiling of null
    date_formats = date_formats || {
      past: [
        { ceiling: 60, text: "$seconds seconds ago" },
        { ceiling: 3600, text: "$minutes minutes ago" },
        { ceiling: 86400, text: "$hours hours ago" },
        { ceiling: 2629744, text: "$days days ago" },
        { ceiling: 31556926, text: "$months months ago" },
        { ceiling: null, text: "$years years ago" }
      ],
      future: [
        { ceiling: 60, text: "in $seconds seconds" },
        { ceiling: 3600, text: "in $minutes minutes" },
        { ceiling: 86400, text: "in $hours hours" },
        { ceiling: 2629744, text: "in $days days" },
        { ceiling: 31556926, text: "in $months months" },
        { ceiling: null, text: "in $years years" }
      ]
    };
    //Time units must be be ordered largest -> smallest
    time_units = time_units || [
      [31556926, 'years'],
      [2629744, 'months'],
      [86400, 'days'],
      [3600, 'hours'],
      [60, 'minutes'],
      [1, 'seconds']
    ];

    date = new Date(date);
    ref_date = ref_date ? new Date(ref_date) : new Date();
    var seconds_difference = (ref_date - date) / 1000;

    var tense = 'past';
    if (seconds_difference < 0) {
      tense = 'future';
      seconds_difference = 0-seconds_difference;
    }

    function get_format() {
      for (var i=0; i<date_formats[tense].length; i++) {
        if (date_formats[tense][i].ceiling == null || seconds_difference <= date_formats[tense][i].ceiling) {
          return date_formats[tense][i];
        }
      }
      return null;
    }

    function get_time_breakdown() {
      var seconds = seconds_difference;
      var breakdown = {};
      for(var i=0; i<time_units.length; i++) {
        var occurences_of_unit = Math.floor(seconds / time_units[i][0]);
        seconds = seconds - (time_units[i][0] * occurences_of_unit);
        breakdown[time_units[i][1]] = occurences_of_unit;
      }
      return breakdown;
    }

    function render_date(date_format) {
      var breakdown = get_time_breakdown();
      var time_ago_text = date_format.text.replace(/\$(\w+)/g, function() {
        return breakdown[arguments[1]];
      });
      return depluralize_time_ago_text(time_ago_text, breakdown);
    }

    function depluralize_time_ago_text(time_ago_text, breakdown) {
      for(var i in breakdown) {
        if (breakdown[i] == 1) {
          var regexp = new RegExp("\\b"+i+"\\b");
          time_ago_text = time_ago_text.replace(regexp, function() {
            return arguments[0].replace(/s\b/g, '');
          });
        }
      }
      return time_ago_text;
    }

    return render_date(get_format());
  }

  getRawDataFromUrlHash () {
    return window.location.hash.substr(1).split(';').reduce((accumulator, currentValue, currentIndex, array) => {
      let [key, value] = currentValue.split(':');
      if(key) {
        accumulator[decodeURIComponent(key)] = JSON.parse(decodeURIComponent(value));
      }
      return accumulator;
    }, {});
  }

  getDataFromUrlHash (obj, keys) {
    let hash = this.getRawDataFromUrlHash();

    return Object.keys(hash).reduce((accumulator, currentValue, currentIndex, array) => {
      let [mainKey, subKey] = currentValue.split('.');
      if(keys.indexOf(mainKey) > -1) {
        if(subKey) {
          accumulator[mainKey][subKey] = hash[currentValue];
        }
        else {
          accumulator[mainKey] = hash[currentValue];
        }

      }
      return accumulator;
    }, obj);
  }

  setUrlHashByData(obj, keys, stateObj, pageTitle, reset = false) {
    let hash = reset ? {} : this.getRawDataFromUrlHash();

    keys.forEach((key) => {
      if(typeof obj[key] === 'object') {
        hash = Object.keys(obj[key]).reduce((accumulator, currentValue, currentIndex, array) => {
          accumulator[`${key}.${currentValue}`] = obj[key][currentValue];
          return accumulator;
        }, hash);
      }
      else {
        hash[key] = obj[key];
      }
    });

    hash = Object.keys(hash).reduce((accumulator, currentValue, currentIndex, array) => {
      let isArr = this.isArrayish(hash[currentValue]);
      if(hash[currentValue] !== undefined &&
        JSON.stringify(hash[currentValue]) !== "[null]" &&
        ((isArr && hash[currentValue].length) || (!isArr && hash[currentValue]))) {
        accumulator[currentValue] = hash[currentValue];
      }
      return accumulator;
    }, {});

    hash = Object.keys(hash).reduce((accumulator, currentValue, currentIndex, array) => {
      accumulator.push(`${encodeURIComponent(currentValue)}:${encodeURIComponent(JSON.stringify(hash[currentValue]))}`);
      return accumulator;
    }, []).join(';');

    if(reset) {
      window.history.pushState(stateObj, pageTitle, `#${hash}`);
    }
    else {
      window.history.replaceState(stateObj, pageTitle, `#${hash}`);
    }

  }

  /**
   * Field can be "user.id" return  ['user', 'id']
   *
   * @param {string} field
   * @returns {*|string[]}
   */
  chainFields(field) {
    return this.isArrayish(field) ? { fields: field.map(el => this.chainFields(el)) } : field.split('.');
  }

  /**
   * Field in chain can be ['user', 'id'], return "user.id"
   *
   * @param {array} fieldsInChain
   * @returns {string}
   */
  fieldsToString(fieldsInChain) {
    return fieldsInChain.join('.');
  }

  /**
   * Remove object ref totally, only work with static data fits JSON, cannot use for function or instance
   *
   * @param {any} data
   * @returns {any}
   */
  noRefData(data) {
    return JSON.parse(JSON.stringify(data));
  }

  /**
   * @param {object} obj
   * @param {[string|int]} fieldsInChain
   * @returns {any}
   */
  findValue(obj, fieldsInChain) {
    return fieldsInChain.length === 1 ?
      obj[fieldsInChain[0]] :
      /**
       * find value uses array reduce, it can be slow
       */
      fieldsInChain.reduce(function (source, field) {
        return source?.[field];
      }, obj);
  }

  /**
   * Convert Empty (undefined|''|null) to defaultValue, by default it is undefined
   *
   * @param {any} value
   * @param {any} defaultValue
   * @returns {undefined|any}
   */
  convertEmpty(value, defaultValue = undefined) {
    if (this.isArrayish(value)) {
      let arr = [];
      for (let i = 0; i < value.length; i++) {
        arr.push(this.convertEmpty(value[i], defaultValue));
      }
      return arr.filter(el => el);
    }
    value = this.isString(value) ? value.trim() : value;
    return value === null || value === '' || value === undefined ? defaultValue : value;
  }

  /**
   * @callback Tools~filter_dataProcessList_select
   * @param {object} item
   * @return {string|any}
   * @example <caption>select</caption>
   * // (device) => {
   * //   return customData?.[device.id]?.[0];
   * // }
   */

  /**
   * @callback Tools~filter_dataProcessList_where
   * @param {string|number|object} filterValue
   * @param {string|number|object} sourceValue
   * @return {boolean}
   * @example <caption>select</caption>
   * // (filterValue, sourceValue) => {
   * //   return !filterValue || sourceValue === 'test';
   * // }
   */

  /**
   * @param {Object} filterGroup - filterGroup is a object contains filters with value
   * @example <caption>filterGroup</caption>
   * // {
   * //   status: 'passed', //or failed, await, etc
   * //   condition: 'new', //or old, refurbished, etc
   * //   time: 1592529821,
   * // }
   * @param {Object[]} sourceList
   * @param {Object.<string, object>} dataProcessList
   * @param {string} dataProcessList.<string>.undefinedValue
   * @param {Tools~filter_dataProcessList_select} dataProcessList.<string>.select
   * @param {Tools~filter_dataProcessList_where} dataProcessList.<string>.where
   * @example <caption>dataProcessList</caption>
   * // {
   * //   'status': {
   * //     // if select 'N/A', all the items status filed is undefined would be selected, such as: user try
   * //     // to find all the devices has no location/level data, they can select 'N/A', which trigger to have
   * //     // all the devices with level === undefined to be retained
   * //     undefinedValue: 'N/A',
   * //     // to select value, instead select from sourceList, select by custom callback, also, there is no
   * //     // need to filter items by the data supplied from sourceList which is `device` the example
   * //     select: (device) => {
   * //       return this.testResults?.[device.id]?.[0];
   * //     }
   * //   },
   * //   'power_loss': {
   * //     // to apply the custom condition to filter the data, default only support ===
   * //     where: (filterValue, sourceValue) => {
   * //       return !filterValue || sourceValue === 'power_loss';
   * //     }
   * //   },
   * // }
   * @returns {Object[]}
   */
  filter(filterGroup, sourceList, dataProcessList = {}) {
    let fields = Object.keys(dataProcessList);
    for (let i = 0; i < fields.length; i++) {
      let field = fields[i],
        fieldsInChain = this.chainFields(field),
        /**
         * @type {Array|string}
         */
        filterValues = this.findValue(filterGroup, fieldsInChain),
        {
          undefinedValue,
          /**
           * @type {Tools~filter_dataProcessList_select}
           */
          select,
          /**
           * @type {Tools~filter_dataProcessList_where}
           */
          where,
          filterValueConvert
        } = dataProcessList[field];

      filterValues = this.convertEmpty(filterValues);

      let isArr = this.isArrayish(filterValues);

      if (filterValues !== undefined && (!isArr || (isArr && filterValues.length))) {
        if(filterValueConvert !== undefined) {
          filterValues = filterValueConvert(filterValues);
        }
        sourceList = sourceList.filter(el => {
          let sourceValue;

          if (select !== undefined) {
            sourceValue = select(el);
          }
          else {
            sourceValue = this.findValue(el, fieldsInChain);
          }

          sourceValue = this.convertEmpty(sourceValue);

          if (where !== undefined) {
            return where(filterValues, sourceValue);
          }
          else if (isArr) {
            return filterValues.indexOf(sourceValue) > -1 ||
              (
                filterValues.indexOf(undefinedValue) > -1 && sourceValue === undefined
              );
          }
          return sourceValue === filterValues || (filterValues === undefinedValue && sourceValue === undefined);
        })
      }
    }

    return sourceList;
  }

  /**
   * @callback Tools~sort_dataRetrieveCallbackList_field
   * @param {object} a
   * @param {object} b
   * @return {{aData: string|object, bData: string|object}}
   * @example <caption>sort_dataRetrieveCallbackList_field</caption>
   * // (a, b) => {
   * //   return {aData: a.name, bData: b.name};
   * // }
   */

  /**
   *
   * @param {Object[]} sortItems
   * @param {Array.<string|int>} fieldsInChain - Array, eg ['user', 'name'] which defines the property of the input items to sort by
   *     call (new Tools).chainFields('user.name') to convert from 'user.name' to ['user', 'name']
   * @param {boolean} asc
   * @param {boolean} emptyLast - to put undefined, null, "" to the end of the list in ascending
   * @param {object} collatorOptions - {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Collator/Collator}
   * @param {Object.<string, Tools~sort_dataRetrieveCallbackList_field>} dataRetrieveCallbackList - Map of field names to
   *     mapping functions which return the key to sort by
   * @example <caption>dataRetrieveCallbackList</caption>
   * // {
   * //  field: (a, b) => {aData, bData} // would apply to only the field defined here
   * //  '*': (a, b) => {aData, bData} // '*' would apply to all fields sort
   * // }
   * @returns {Object[]}
   */
  sort(
    sortItems,
    fieldsInChain,
    asc = true,
    emptyLast = true,
    collatorOptions = {numeric: true, sensitivity: 'base'},
    dataRetrieveCallbackList = undefined,
    numberLast = false,
  ) {
    let collator = new Intl.Collator(undefined, collatorOptions),
      order = asc ? 1 : -1,
      {fields : fieldsInChainList = [fieldsInChain]} = fieldsInChain,
      /**
       * @type {Tools~sort_dataRetrieveCallbackList_field}
       */
      dataRetrieveCallback = this.convertEmpty(
        dataRetrieveCallbackList?.[this.fieldsToString(fieldsInChain)],
        dataRetrieveCallbackList?.['*']
      ),
      sortFn = (a, b, fieldsInChainTmp) => {
        let aData, bData, compare;
        if (dataRetrieveCallback !== undefined) {
          ({aData, bData} = dataRetrieveCallback(a, b));
        }
        else {
          aData = this.findValue(a, fieldsInChainTmp);
          bData = this.findValue(b, fieldsInChainTmp);
        }

        aData = this.convertEmpty(aData);
        bData = this.convertEmpty(bData);
        if (aData !== bData && (aData === undefined || bData === undefined)) {
          compare = aData === undefined === emptyLast ? 1 : -1;
        }
        else {
          if (numberLast) {
            if(this.isNumber(aData?.toString()?.[0]) && !this.isNumber(bData?.toString()?.[0])) {
              compare = 1;
            }
            else {
              if(!this.isNumber(aData?.toString()?.[0]) && this.isNumber(bData?.toString()?.[0])) {
                compare = -1;
              }
              else {
                compare = collator.compare(aData, bData);
              }
            }
          }
          else {
            compare = collator.compare(aData, bData);
          }
        }

        return compare;
      };

    sortItems = sortItems.sort((a, b) => {
      let compare = 0;
      for(let i = 0; i < fieldsInChainList.length; i++) {
        compare = sortFn(a, b, fieldsInChainList[i]);
        if(compare) {
          break;
        }
      }
      return compare * order;
    });

    return sortItems;
  }

  // TODO remove this deprecated function which operates on emiot users instead of firebase or plexus users
  userInitial ({first_name = '', last_name = '', email = ''}) {
    if (first_name && last_name) {
      return first_name.charAt(0).toUpperCase() + last_name.charAt(0).toUpperCase();
    }
    else if (email) {
      return email.charAt(0).toUpperCase() + email.charAt(1).toUpperCase();
    }

    return 'N/A';
  }

  /**
   * @param user {firebase.User}
   * @returns {string}
   */
  userInitials (user) {
    if (user.displayName) {
      const names = user.displayName.split(' ')
      const firstInitial = names[0].charAt(0).toUpperCase();
      const lastInitial = names.length > 1 ? names[names.length - 1].charAt(0).toUpperCase() : '';
      return firstInitial + lastInitial
    }
    else if (user.email) {
      return user.email.charAt(0).toUpperCase() + user.email.charAt(1).toUpperCase();
    }

    return 'N/A';
  }

  ucwords(data) {
    data = data ? data.split(' ') : [];
    for (let i in data) {
      data[i] = this.ucfirst(data[i]);
    }

    return data.join(' ');
  }

  ucfirst(str) {
    str = str ? str : '';
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  /**
   * Check is given valuable array
   *
   * @param {*} obj
   * @return {bool}
   */
  isArrayish(obj) {
    if (!obj) {
      return false;
    }

    return obj instanceof Array || Array.isArray(obj) ||
      (obj.length >= 0 && obj.splice instanceof Function);
  }

  /**
   * Check is given valuable string
   *
   * @param {*} str
   * @return {bool}
   */
  isString(str) {
    return typeof str === 'string' || str instanceof String
  }

  isNumber(num) {
    if (typeof num === 'string' || num instanceof String) {
      if (!num.trim()) return false;
    } else if (typeof num !== 'number' && !(num instanceof Number)) {
      return false;
    }

    return (num - num + 1) >= 0;
  };

  /**
   * @typeof {Object} nameMapping - mapping object for title, css; key is used for mapping
   * @property {mappingItem} nameMapping.{string}
   *
   * @typeof {Array} mappingItem
   * @property {string} mappingItem[0] - title text
   * @property {string} mappingItem[1] - css class
   * @property {nameMapping} mappingItem[2] - sub mapping
   *
   * @example <caption>nameMapping</caption>
   * // {
   * //   'aaa': [
   * //     'aaa 1',
   * //     'aaa 2',
   * //     {
   * //       'bbb': ['bbb 1', 'bbb 2', 'aaa']
   * //       'ccc': ['ccc 1', 'ccc 2', 'aaa']
   * //     }
   * //   ]
   * // }
   *
   * @typeof {Object} flatNameMapping - flatted mapping object for title, css; key is used for mapping
   * @property {mappingItem} flatNameMapping.{string}
   *
   * @typeof {Array} flatNameMappingItem
   * @property {string} flatNameMappingItem[0] - title text
   * @property {string} flatNameMappingItem[1] - css class
   * @property {int} flatNameMappingItem[2] - parent key
   *
   * @example <caption>flatNameMapping</caption>
   * // {
   * //   'aaa': ['aaa 1', 'aaa 2']
   * //   'bbb': ['bbb 1', 'bbb 2', 'aaa'], // 'aaa' index is 2, therefore, the pkIndex == 2
   * //   'ccc': ['ccc 1', 'ccc 2', 'aaa'], // 'aaa' index is 2, therefore, the pkIndex == 2
   * // }
   */

  /**
   * Convert flat data to hierarchy
   *
   * @param {string} selectedKey
   * @param {int} pkIndex
   * @param {flatNameMapping} flatList
   *
   * @return {nameMapping}
   */
  buildTree(selectedKey, pkIndex, flatList) {
    let keys = Object.keys(flatList),
      obj = {};
    keys = keys.filter(key => flatList[key][pkIndex] === selectedKey);

    for (let i = 0; i < keys.length; i++) {
      let key = keys[i];
      obj[key] = flatList[key].slice(0);
      obj[key][pkIndex] = this.buildTree(key, pkIndex, flatList);
    }

    return obj;
  }

  /**
   * get key list from a flat list for parent only
   *
   * @param {string} selectedKey
   * @param {int} pkIndex
   * @param {flatNameMapping} flatList
   * @param {Array.<string>} arrKeys
   * @return {Array.<string>}
   */
  getParentList(selectedKey, pkIndex, flatList, arrKeys = []) {
    arrKeys.unshift(selectedKey);

    let parentKey = flatList[selectedKey]?.[pkIndex];

    if(parentKey) {
      this.getParentList(parentKey, pkIndex, flatList, arrKeys);
    }

    return arrKeys;
  }

  /**
   * get child keys
   *
   * @param {string} selectedKey
   * @param {int} pkIndex
   * @param {flatNameMapping} flatList
   * @param {bool} allChildren
   * @return {Array.<string>}
   */
  getChildList(selectedKey, pkIndex, flatList, allChildren = true) {
    let children = Object.keys(flatList).reduce((accumulator, currentValue, currentIndex, array) => {
      let parentKey = flatList[currentValue][pkIndex];
      if(parentKey && parentKey === selectedKey) {
        accumulator.push(currentValue);
      }
      return accumulator;
    }, []);

    if (allChildren) {
      for(let i = 0; i < children.length; i++) {
        children.push(...this.getChildList(children[i], pkIndex, flatList));
      }
    }

    return children;
  }

  /**
   * Toggle value in an array, only work with none object/array value
   *
   * @param {number|string} value
   * @param {Array} dataSet
   */
  toggleEl(value, dataSet) {
    let i = dataSet.indexOf(value);
    if (i > -1) {
      dataSet.splice(i, 1);
    }
    else {
      dataSet.push(value);
    }
  }

  /**
   * Add unique value in an array, only work with none object/array value
   *
   * @param {number|string} value
   * @param {Array} dataSet
   */
  addEl(value, dataSet) {
    let i = dataSet.indexOf(value);
    if (i < 0) {
      dataSet.push(value);
    }
  }

  /**
   * Remove value in an array (including duplicated values), only work with none object/array value
   *
   * @param {number|string} value
   * @param {Array} dataSet
   */
  removeEl(value, dataSet) {
    let i = dataSet.indexOf(value);
    if (i > -1) {
      dataSet.splice(i, 1);
      this.removeEl(value, dataSet);
    }
  }

  /**
   * Use limited works to process items by supplied function
   *
   * @param {int} limits, how many works run at the same time
   * @param {Array} items, the raw items need to be processed, no promise in any items
   * @param {Function} promiseFn, the callback function to process each item, the function should accept (index, item) as parameters
   * @return {Q.Promise<Array<Q.PromiseState<any>>>}
   */
  asyncPool(limits, items, promiseFn) {
    let responses = [];

    async function doWork(iterator) {
      for (let [index, item] of iterator) {
        responses.push(await promiseFn(index, item));
      }
    }

    let iterator = items.entries();
    let promises = new Array(limits).fill(iterator).map(doWork);

    return Promise.allSettled(promises).then(() => responses);
  }

  /**
   * Populate id for vue elements, id format: prefix_uniqueId_postfix; ref id format: #prefix_uniqueId_postfix
   *
   * @param component
   * @param {string} prefix
   * @param {string} postfix
   * @param {boolean} ref
   * @return {string}
   */
  getId(component, prefix, postfix, ref = false) {
    let id = `${prefix}_${component._uid}_${postfix}`;
    return ref ? `#${id}` : id;
  }
}